import React from 'react'
import { PricingAvailabilityItem } from '@src/aem-content/aem-types'
import { useAddToCartWithGlobalSnackbar } from '@src/utils/useCart'
import { SitePreference, useCurrentUser } from '@src/utils/useCurrentUser'
import { Form, Formik } from 'formik'
import DiscoPromoMaterialPricing from './DiscoPromoMaterialPricing'
import { Abilities, useAbility } from '@src/utils/useAbility'

type DiscoPromoProductPriceFormProps = {
  product?: string
  materialPricing: PricingAvailabilityItem[]
  dchainMessage?: string
  currentDtaqDealer?: string | null
  isMarketplace?: boolean
  onAddToCartResult?: () => void
}

const DiscoPromoProductPriceForm = ({
  product,
  materialPricing,
  dchainMessage,
  currentDtaqDealer,
  isMarketplace,
  onAddToCartResult,
}: DiscoPromoProductPriceFormProps) => {
  const { authorized } = useAbility(Abilities.canAddToCart)
  const handleAddToCart = useAddToCartWithGlobalSnackbar()
  const {
    getSitePreference,
    isDTAQZuCustomer,
    isMultiCountryUser,
    currentUser,
  } = useCurrentUser()

  const hideAddToCartForPrepackItems = getSitePreference(
    SitePreference.HideAddToCartForPrepackItems
  )

  if (!materialPricing?.length) return null

  const preferredDealerId = isDTAQZuCustomer
    ? getSitePreference(SitePreference.PreferredDealerId)
    : null

  const loadInitialFormValues = (
    productPricing: PricingAvailabilityItem[],
    preferredDealerId: string | null
  ) => {
    if (productPricing) {
      return productPricing.reduce(
        (acc, { materialNumber, marketplace_offer_id }, index) => {
          return {
            ...acc,
            [index]: {
              materialNumber,
              marketplace_offer_id,
              quantity: '',
              dealerId: preferredDealerId,
            },
          }
        },
        {}
      )
    } else return []
  }

  return (
    <Formik
      enableReinitialize
      initialValues={loadInitialFormValues(materialPricing, preferredDealerId)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        const items = Object.keys(values)
          .map((key) => ({
            materialNumber: values[key].materialNumber,
            quantity: Number(values[key].quantity),
            dealerId: currentDtaqDealer,
            marketplaceOfferId: values[key].marketplace_offer_id,
          }))
          .filter((value) => value.quantity)

        handleAddToCart(items, setSubmitting, resetForm, isMarketplace).then(
          onAddToCartResult
        )
      }}
    >
      {({
        isSubmitting,
        dirty,
        submitForm,
        resetForm,
        setFieldValue,
        values,
      }) => (
        <Form>
          <DiscoPromoMaterialPricing
            product={product}
            materialPricing={materialPricing}
            hideAddToCartForPrepackItems={hideAddToCartForPrepackItems}
            isSubmitting={isSubmitting}
            dirty={dirty}
            submitForm={submitForm}
            resetForm={resetForm}
            setFieldValue={setFieldValue}
            values={values}
            isMarketplace={isMarketplace}
            canAddToCart={
              authorized &&
              !isMultiCountryUser &&
              (!isMarketplace ||
                (isMarketplace &&
                  !!currentUser?.metadata?.isMarketplaceCartEnabled))
            }
            isMarketplaceCartEnabled={
              !!currentUser?.metadata?.isMarketplaceCartEnabled
            }
            dchainMessage={dchainMessage}
          />
        </Form>
      )}
    </Formik>
  )
}
export default DiscoPromoProductPriceForm
